import { render } from "./DocumentList.vue?vue&type=template&id=f35e790a&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"

import "./DocumentList.vue?vue&type=style&index=0&id=f35e790a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35e790a"]])

export default __exports__